<script>
import { getBuyerTeam } from '@/graphql/buyer/queries.graphql';

import { QueryHelper } from '@/components/Core/Helpers';

export default {
  mixins: [QueryHelper],
  props: {
    invitesFilter: {
      type: Object,
      default: null
    }
  },

  query(props) {
    return {
      query: getBuyerTeam,
      variables: {
        invitesFilter: props.invitesFilter,
        buyer_id: this.$store.getters['auth/buyerId']
      }
    };
  }
};
</script>
